import React, { useEffect } from 'react';
import {
  FormControl,
  FormControlProps,
  MenuItem,
  Select,
  SelectChangeEvent,
  Typography,
} from '@mui/material';
import { useDispatch } from 'react-redux';

import { getSessionState, selectStudent } from '../../../../store/SessionSlice';
import { TP_COLORS } from '../../../../constants';
import { ISessionUser } from '..';
import { useAppSelector } from '../../../../hooks';

const selectProps: FormControlProps = {
  variant: 'standard',
  sx: {
    paddingTop: '2px',
    paddingLeft: '5px',
    color: TP_COLORS.white,
  },
  size: 'small',
};

interface ISessionStudents {
  subjectColor: string;
  relatedStudents?: Array<ISessionUser>;
  onChangeStudent?: (studentId: string) => void;
}

const SessionStudents: React.FC<ISessionStudents> = ({
  subjectColor,
  relatedStudents,
  onChangeStudent,
}) => {
  const dispatch = useDispatch();

  const sessionState = useAppSelector(getSessionState);
  const { selectedStudent } = sessionState;

  useEffect(() => {
    if (relatedStudents && relatedStudents.length) {
      if (!selectedStudent && !relatedStudents[0].autoConnectDisabled) {
        handleStudentChange(relatedStudents[0]._id);
      } else if (
        !relatedStudents.find((student) => student._id === selectedStudent)
      ) {
        handleStudentChange('');
      } else {
        handleStudentChange(selectedStudent);
      }
    }
  }, [relatedStudents]);

  const handleStudentChange = (studentId: string) => {
    dispatch(selectStudent(studentId));
    if (onChangeStudent) {
      onChangeStudent(studentId);
    }
  };

  return relatedStudents ? (
    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
      <Typography variant="subtitle1" color={subjectColor}>
        Connected: {relatedStudents.length === 0 ? 'No Students' : ''}
      </Typography>
      {relatedStudents.length > 0 ? (
        <FormControl {...selectProps}>
          <Select
            autoWidth
            displayEmpty
            id="student-select"
            value={selectedStudent}
            onChange={(event: SelectChangeEvent) =>
              handleStudentChange(event.target.value)
            }
            disableUnderline
            sx={{
              color: subjectColor,
              '.MuiSvgIcon-root ': {
                fill: subjectColor,
              },
            }}
          >
            <MenuItem key="" value="">
              Original Resources
            </MenuItem>
            {relatedStudents.map((element) => (
              <MenuItem
                key={element._id}
                value={element._id}
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  flexDirection: 'row',
                }}
              >
                <span>
                  {element.firstname} {element.lastname}
                </span>
                {element.isOnline && (
                  <span style={{ color: 'green', marginLeft: '8px' }}>●</span>
                )}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      ) : null}
    </div>
  ) : null;
};

export default SessionStudents;
